/**
 * Verbindungs-Status (Option B, 06.07.2026).
 *
 * BuildBook ist server-autoritativ: „verbunden" heißt, die eine Datenbank auf
 * dem Server ist erreichbar — dann sind Ansehen und Speichern live. Der Status
 * kombiniert das Netz (navigator.onLine) mit der tatsächlichen Server-
 * Erreichbarkeit, die der api-client meldet (echter Request-Fehler → offline,
 * erfolgreiche Antwort → online). So spiegelt die Anzeige nicht nur das WLAN,
 * sondern ob der Server wirklich antwortet.
 *
 * Modul-Singleton: ein gemeinsamer Zustand für die ganze App.
 */

import { ref, computed, type ComputedRef } from 'vue';

const netz = ref(typeof navigator !== 'undefined' ? navigator.onLine : true);
const serverErreichbar = ref(true);

if (typeof window !== 'undefined') {
  window.addEventListener('online', () => { netz.value = true; });
  window.addEventListener('offline', () => { netz.value = false; });
}

const online = computed(() => netz.value && serverErreichbar.value);

/** Vom api-client aufgerufen: Server hat geantwortet. */
export function meldeServerOk(): void {
  serverErreichbar.value = true;
}

/** Vom api-client aufgerufen: Request scheiterte am Netz/Server. */
export function meldeServerFehler(): void {
  serverErreichbar.value = false;
}

export function useOnline(): ComputedRef<boolean> {
  return online;
}
